<span *ngIf="opened" class="sidebar-item-text">
  <!-- <span *ngIf="opened"> -->
  {{ text }}
  <!-- </span> -->
</span>
